import { render } from "./FacebookSvg.vue?vue&type=template&id=582fe6bd"
import script from "./FacebookSvg.vue?vue&type=script&lang=js"
export * from "./FacebookSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__